// extracted by mini-css-extract-plugin
module.exports = {"cookies":"Cookies-module--cookies--32OZL"};